


export const layouts = {
'FooterV2': () => import('/builds/nangman/nangman-web/src/layouts/FooterV2.vue'),
'Header': () => import('/builds/nangman/nangman-web/src/layouts/Header.vue'),
'IntroHeader': () => import('/builds/nangman/nangman-web/src/layouts/IntroHeader.vue'),
'analysis': () => import('/builds/nangman/nangman-web/src/layouts/analysis.vue'),
'auth': () => import('/builds/nangman/nangman-web/src/layouts/auth.vue'),
'blank': () => import('/builds/nangman/nangman-web/src/layouts/blank.vue'),
'customer': () => import('/builds/nangman/nangman-web/src/layouts/customer.vue'),
'empty': () => import('/builds/nangman/nangman-web/src/layouts/empty.vue'),
'essay': () => import('/builds/nangman/nangman-web/src/layouts/essay.vue'),
'intro': () => import('/builds/nangman/nangman-web/src/layouts/intro.vue'),
'login': () => import('/builds/nangman/nangman-web/src/layouts/login.vue'),
'm-saju-insight': () => import('/builds/nangman/nangman-web/src/layouts/m-saju-insight.vue'),
'main': () => import('/builds/nangman/nangman-web/src/layouts/main.vue'),
'manse': () => import('/builds/nangman/nangman-web/src/layouts/manse.vue'),
'mypage': () => import('/builds/nangman/nangman-web/src/layouts/mypage.vue'),
'print': () => import('/builds/nangman/nangman-web/src/layouts/print.vue'),
'purchase': () => import('/builds/nangman/nangman-web/src/layouts/purchase.vue'),
'saju-service': () => import('/builds/nangman/nangman-web/src/layouts/saju-service.vue'),
'white': () => import('/builds/nangman/nangman-web/src/layouts/white.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top && route.meta?.layout !== false) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout || 'default'],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
